import { PayloadAction, createSlice } from '@reduxjs/toolkit'

const initialState = {
    token: localStorage.getItem('token') ? JSON.parse(localStorage.getItem('token') || '') : null
}

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        saveAwsToken: (state, action: PayloadAction<string | null>) => {
            state.token = action.payload
            localStorage.setItem('token', action.payload || '')
        }
    }
})

export default userSlice.reducer

export const { saveAwsToken } = userSlice.actions

export const currentUser = (state: any) => state.user
